import React, { Component, Fragment } from 'react'
import { LanguageConsumer, Translate } from '../../../contexts/LanguageContext';
import { Loading, BreadCrumb, Card, UserAccounts } from '../../../components';
import { Rules, TransferOptionUrl } from '../../../components/Payment';
import { TransferOptionService } from '../../../services/TransferOptionService';
import { PaymentService } from '../../../services/PaymentService';
import { Popover, PopoverBody } from 'reactstrap';
let user = JSON.parse(localStorage.getItem('user'));
let activeAccount = localStorage.getItem('userActiveAccount') || (user ? user.login : "");

export class BtcPay extends Component {

    constructor(props) {
        super(props)

        this.state = {
            loading: true,
            paymentOptions: {
                acceptedCurrencies: [],
                description: "",
                rules: [],
                title: ""
            },
            // Payment Form
            login: activeAccount,
            paymentInfo: {
                qrCodeImage: "",
                address: "",
                message: "",
                btcPrice: 0,
                error: false
            },
            error: false,
            errorMessage: "",
            popover_dismiss: false,
        }
        this.onCopy = this.onCopy.bind(this);
    }
    componentWillMount() {
        TransferOptionService.Deposit.OptionPage(TransferOptionUrl()).then(response => {
            this.setState({
                paymentOptions: response,
                currency: response.acceptedCurrencies[0],
                error: false
            })
        });
    }
    changeAccount(userAccount) {

        let isChanged = (userAccount.active !== this.state.login);
        this.setState({
            login: userAccount.active
        }, () => {
            if (isChanged)
                this.getPaymentInfo();
        });
    }

    getPaymentInfo(login = this.state.login, isNew = false) {

        this.setState({
            loading: true
        }, () => {

            PaymentService.Deposit.BtcPay({
                login: login, isNew: isNew
            }).then(response => {
                this.setState({
                    paymentInfo: response,
                    error: response.error,
                    errorMessage: response.message,
                    loading: false
                })
            });

        });



    }

    createNewAddress() {
        this.getPaymentInfo(this.state.login, true);
    }
    onCopy() {
        this.setState({ popover_dismiss: true });
        navigator.clipboard.writeText(this.state.paymentInfo.address);
        setTimeout(() => {
            this.setState({ popover_dismiss: !this.state.popover_dismiss })
        }, 2000);
    }

    render() {
        return (

            <LanguageConsumer>
            {() => (
                <Fragment>
                    <Loading Show={this.state.loading} Title={Translate("Loading Content")} />
                    <BreadCrumb Title={this.state.paymentOptions.title} Name={this.state.paymentOptions.title} SubTitle={Translate("Deposit")} SubUrl="/deposit" />
                    <Card Title={this.state.paymentOptions.title} Description={this.state.paymentOptions.description} Logo={this.state.paymentOptions.logo}>
                        <div className="row">
                            <div className="col-md-12">
                                <Rules Items={this.state.paymentOptions.rules} />
                            </div>
                            <div className={"col-md-12 " + (this.state.error ? "" : "d-none")}>
                                <div className={"alert alert-danger alert-dismissible fade mb-0 show"} role="alert">
                                    <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    <strong>{Translate("Error !")}</strong> {this.state.errorMessage}
                                </div>
                            </div>
                            <div className="col-md-8">
                                <h4 className="mt-0 header-title m-b-20 mt-4 text-dark"><i className="fas fa-file-invoice"></i>{Translate("&nbsp; Payment Form")}</h4>
                                <div className="form-group row ml-3">
                                    <label htmlFor="example-text-input" className="col-sm-2 col-form-label">{Translate("Account")}</label>
                                    <div className="col-sm-10">
                                        <UserAccounts List className="bg-dark" Change={(e, userAccount) => this.changeAccount(userAccount)}  Status="deposit"/>
                                    </div>
                                </div>

                                <div className="form-group row ml-3">
                                    <label htmlFor="amount" className="col-sm-2 col-form-label">{Translate("Transfer Address")}</label>
                                    <div className="col-sm-8">
                                        <div className="input-group bootstrap-touchspin bootstrap-touchspin-injected">
                                            <input type="text" readOnly value={this.state.paymentInfo.address} className="form-control" />
                                            <span className="input-group-append">
                                                <button type="button" id="Popoverdismiss" className="btn btn-success waves-effect waves-light" ><i className="fas fa-copy"></i></button>
                                                <Popover placement="left" isOpen={this.state.popover_dismiss} target="Popoverdismiss" toggle={() => this.onCopy()}>
                                                    <PopoverBody>{Translate("Copied !")}</PopoverBody>
                                                </Popover>
                                                {/* <button type="button" className="input-group-text" onClick={(e)=>this.onCopy()}><i className="fas fa-copy"></i></button> */}
                                            </span>
                                        </div>
                                        {/* <input className="form-control" type="text" readOnly value="3QoDu7G83HJe2q7THF3MS2rAgr8rUpocoW" /> */}
                                    </div>
                                    <div className="col-sm-2">
                                        <button type="button" className="btn btn-sm btn-info p-2" onClick={(e) => this.createNewAddress()}>{Translate("Create New Address")}</button>
                                    </div>
                                </div>
                                <div className="row ml-3">
                                    <div className="col-sm-12">
                                        <div className="card text-white bg-secondary">
                                            <div className="card-body">
                                                <blockquote className="card-blockquote mb-0">
                                                    <div className="row">
                                                        <div className="col-md-9">
                                                            {Translate("")} <p>{Translate("Important:")} <span className="text-warning"><strong>  {Translate("Approximate BTC Price :")} {this.state.paymentInfo.btcPrice.format('C')} USD</strong></span></p>
                                                            <ul>
                                                                <li>
                                                                    {Translate("The <u><i>minimum</i></u> deposit amount is ")}<span className="text-warning"><strong>0.003 BTC</strong></span> . {Translate("Deposits under this amount are not considered and will not be refunded.")}
                                                                </li>
                                                                <li>
                                                                    {Translate("The displayed addresses are defined for you and balances are automatically added to your MetaTrader account.")}
                                                                </li>
                                                                <li>
                                                                    {Translate("You can create addresses using the Create new address button, but you must have used your previous addresses at least once.")}
                                                                </li>
                                                                <li>
                                                                    {Translate("Given rates are indicative online prices. It may vary depend on BTC arrive time. Exchange rates are calculating after the BTC arrives.")}
                                                                </li>
                                                            </ul>

                                                        </div>
                                                        <div className="col-md-3">
                                                            <img className="img-fluid" src={this.state.paymentInfo.qrCodeImage} alt="QrCode" />
                                                        </div>
                                                    </div>
                                                </blockquote>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Card>
                </Fragment>
            )}
        </LanguageConsumer>
           
        )
    }
}